// extracted by mini-css-extract-plugin
module.exports = {"main_container_brand":"Brand_main_container_brand__3Ip7d","brand":"Brand_brand__24u4l","img_brands":"Brand_img_brands__1h__I"};